import { Modal, Row, Col, Button } from "antd";
import React from "react";

const DeleteReportModal = ({ open, reportName, loading, onCancel, onConfirm }) => {
  return (
    <Modal
      className="candidateDeleteModal"
      centered
      width={392}
      getContainer={document.body}
      onCancel={onCancel}
      open={open}
      footer={null}
      title={"Delete Report?"}
    >
      <Row className="header">
        <Col>
          <p className="desc">
            Are you sure you want to permanently delete the <span>{reportName}</span> ?
          </p>
        </Col>
      </Row>

      <Row align="middle" gutter={16} justify="end">
        <Col>
          <Button className="confirmBtn" onClick={onConfirm} loading={loading}>
            Delete
          </Button>
        </Col>
        <Col>
          <Button className="cancelBtn" onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default DeleteReportModal;
